import React, {useState, useContext, useEffect} from 'react';
import {
  StyleSheet,
  Text,
  View,
  Pressable,
  Modal,
  Platform,
  SectionList,
} from 'react-native';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import ScreenContext from '../../ScreenContext';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';
import Styles from '../../Styles';
import BottomSheet, {
  BottomSheetBackdropProps,
  BottomSheetScrollView,
} from '@gorhom/bottom-sheet';
import {
  MenuProductType,
  ProductModifierType,
  ProductModifierValue,
  TabType,
} from 'src/types/Menu';
import PromotionTypes from 'src/constants/cart/PromotionTypes';
import AccountStore from 'src/stores/AccountStore';
import {LocationType} from 'src/types/Location';
import CartStore from 'src/stores/CartStore';
import CartService from 'src/services/CartService';
import AccountConstants from 'src/constants/AccountConstants';
import {
  ScrollView,
} from 'react-native-gesture-handler';
import MenuService from 'src/services/MenuService';
import Util from 'src/Util';
import TransactionStore from 'src/stores/TransactionStore';
import Localized from 'src/constants/AppStrings';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import Logger from 'src/logging/Logger';
import {getDescriber} from 'src/components/screens/orderAhead/descriptor/DescriptorType';
import Settings from 'src/Settings';
import CancelIcon from 'src/components/img/svg/CancelIcon';
import SafeAreaView from 'src/components/elements/SafeAreaView';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {CartItemType} from 'src/components/elements/cart/CartToastView';
import {
  withGlobalize,
  WithGlobalizeProps,
} from '../../../i18n/HOC/withGlobalize';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

const {
  upsellSelectedBackground,
  upsellSheetStyles,
  getUpsellButton,
  calorieTextColor,
  getPickupLocationStyles,
} = getDescriber();

const {mainFontFamily} = getLayoutDescriber();

type ProductUpsellSheetScreenProps = WithGlobalizeProps & {
  product: MenuProductType;
  tabs: Array<TabType>;
  selections: {string: string[]};
  location: LocationType;
};

enum BottomSheetState {
  NOT_READY = 'NOT_READY',
  FULLY_OPEN = 'FULLY_OPEN',
  FULLY_CLOSED = 'FULLY_CLOSED',
}

const ProductUpsellSheetScreen = (props: ProductUpsellSheetScreenProps) => {
  const insets = useSafeAreaInsets();
  const context = useContext(ScreenContext);
  const tab = props.tabs[0];
  let addItemClicked = false;

  let bottomSheetCurrentState: BottomSheetState = null;

  const [itemCount, setItemCount] = useState<number>(0);
  const [selectedModifiers, setSelectedModifiers] = useState(
    props.selections ? props.selections : {},
  );
  const [refresh, setRefresh] = useState(true);
  const [totalItemsSelected, setTotalItemsSelected] = useState<number>(0);
  const [upsellPriceTotal, setUpsellPriceTotal] = useState<number>(0);
  const [visisble, setVisible] = useState<boolean>(true);

  useEffect(() => {
    let count = 0;
    props.selections &&
      Object.keys(props?.selections)
        .map((key) => props?.selections[key])
        .map((item) => {
          count = count + item.length;
        }, []);
    setTotalItemsSelected(count);
  }, []);

  const bottomSheetRef: React.RefObject<BottomSheet> = React.createRef();

  const addItem = (isClose = false) => {
    addItemClicked = true;
    FirebaseAnalytic.trackEvent(
      isClose ? 'closeUpsellTab' : 'addItem',
      'ProductUpsellSheetScreen',
      {
        ...props,
      },
    );
    if (Object.keys(selectedModifiers).length !== 0) {
      const modifiers = [];
      Object.keys(selectedModifiers).forEach((modifier: string) => {
        selectedModifiers[modifier].forEach((modifierVal: string) => {
          modifiers.push(
            MenuService.getCartModifier(modifierVal) ||
              MenuService.getCartModifierForFreeText(modifier, modifierVal),
          );
        });
      });
      //Set Upsell Modifiers
      CartStore.setUpsellModifiers(tab.id, modifiers);
    }
    toNextScreen(isClose);
  };

  const isModifierValueSelected = (
    modifierId: string,
    modifierValue: string,
  ): boolean => {
    if (selectedModifiers.hasOwnProperty(modifierId)) {
      if (selectedModifiers[modifierId].indexOf(modifierValue) >= 0) {
        return true;
      }
    }
    return false;
  };

  const modifierSelected = (
    modifierId: string,
    modifierValue: string,
    price?: number,
  ) => {
    const modifiers = selectedModifiers;
    if (modifiers.hasOwnProperty(modifierId)) {
      const index = modifiers[modifierId].indexOf(modifierValue);
      if (index >= 0) {
        modifiers[modifierId].splice(index, 1);
        modifiers[modifierId].length === 0 && delete modifiers[modifierId];
        setUpsellPriceTotal((prev) => prev - price);
      } else {
        modifiers[modifierId].push(modifierValue);
        setUpsellPriceTotal((prev) => prev + price);
      }
    } else {
      modifiers[modifierId] = [modifierValue];
      setUpsellPriceTotal((prev) => prev + price);
    }

    let numberOfItems = 0;

    Object.keys(modifiers)
      .map((key) => modifiers[key])
      .map((item) => {
        numberOfItems = numberOfItems + item.length;
      }, []);

    setItemCount(numberOfItems - totalItemsSelected);
    setSelectedModifiers(modifiers);
    setRefresh(!refresh);
  };

  const updateCart = async () => {
    FirebaseAnalytic.trackEvent('updateCart', 'ProductUpsellSheetScreen', {
      ...props,
    });
    const allItems = TransactionStore.getAllItems();
    const pendingItem = CartStore.getPendingItem();
    const pendingQty = CartStore.getPendingQuantity();
    const prepMethodDeafults = TransactionStore.getPreparationMethodDefaults(
      props.location,
    );
    //Adding modifiers as individual product
    const filteredProductItems =
      MenuService.filterProductModifiers(pendingItem);

    for (let i = 0; i < pendingQty; i++) {
      allItems.unshift(...filteredProductItems);
    }

    const item = allItems[0];
    const pendingMods = CartStore.getPendingModifiers();
    const existingMods = item.Modifiers ? item.Modifiers : [];
    allItems[0] = {
      ...item,
      Modifiers: [...existingMods, ...pendingMods],
    };
    //Adding upsell modifiers as products
    const filteredItemsWithPendingMods = MenuService.filterProductModifiers(
      allItems[0],
    );
    filteredItemsWithPendingMods.shift();
    allItems.unshift(...filteredItemsWithPendingMods);
    const discountCodeValue =
      props.location.locationFeatures.is365PayAfterTaxPromo &&
      TransactionStore.isAfterTaxPromoApplied()
        ? PromotionTypes.AfterTaxPromo
        : null;

    //Update cart with item and upsell modifiers
    const response = await CartService.updateCart(
      props.location.locationId,
      AccountStore.getAccountId(),
      [],
      allItems,
      AccountConstants.SOS_LOCATION_TYPE,
      props.product.scancode,
      TransactionStore.getPickupTime(),
      prepMethodDeafults.selectedMethod,
      context,
      discountCodeValue,
    );
    Logger.Log.LogAPIEvent(
      'CartAPI',
      'updateCart',
      JSON.stringify({locationId: props.location.locationId}),
      JSON.stringify(response),
    );
    context.actions.showToast(CartItemType.Menu);

    return response;
  };

  const toNextScreen = async (isClose = false) => {
    if (addItemClicked && isClose) {
      return;
    }
    const allTabs = [...props.tabs];

    allTabs.shift();

    if (allTabs.length > 0) {
      bottomSheetRef.current?.close();
      NavActions.pop();
      NavActions.navigate(
        AppRoutes.ProductUpsellSheet,
        {
          ...props,
          tabs: allTabs,
          selections: {},
        },
        tab.id,
      );
    } else {
      bottomSheetRef.current?.close();
      context.actions.showSpinner();
      const result = await updateCart();

      if (result) {
        context.actions.hideSpinner();
        NavActions.popToRoute(AppRoutes.Menu, {
          location: props.location,
        });
      }
    }
  };

  const renderWebModal = () => {
    const addItemButtonText =
      itemCount > 0
        ? `${Localized.Labels.formatString(
            Localized.Buttons.add_items_selected,
            itemCount,
          )}`
        : Localized.Buttons.add_items;

    return (
      <Modal
        transparent
        visible={true}
        onRequestClose={() => {
          setVisible(false);
          toNextScreen(true);
        }}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <Pressable
              onPress={() => toNextScreen(true)}
              style={styles.closeIcon}
              nativeID="Btn Close modal"
              accessibilityLabel="Close modal"
              accessibilityRole="button"
              hitSlop={Styles.HitSlop_10}
            >
              <CancelIcon />
            </Pressable>

            <ScrollView
              contentContainerStyle={styles.scrollContainer}
              showsVerticalScrollIndicator={false}
            >
              <Text style={styles.tabDescription}>{tab.desc}</Text>

              {renderUpsellSections(tab.modifiers)}

              <View style={styles.buttonView}>
                {getUpsellButton({
                  onPress: () => addItem(),
                  isDiabled: itemCount <= 0,
                  label: addItemButtonText,
                  rightText: Util.formatCurrency(
                    props,
                    upsellPriceTotal,
                    AccountStore.getCurrency(),
                  ),
                })}
              </View>
            </ScrollView>
          </View>
        </View>
      </Modal>
    );
  };

  const renderProduct = (item: ProductModifierValue, modifierId: string) => {
    const calUnit = props.location?.locationFeatures?.dna
      ?.showCaloriesAsKilocalories
      ? Localized.Labels.kcal
      : Localized.Labels.cal_not_all_caps;
    return (
      <Pressable
        style={[
          isModifierValueSelected(modifierId, item.id)
            ? styles.productViewHighlight
            : styles.productView,
          styles.extraStyles,
        ]}
        onPress={() => modifierSelected(modifierId, item.id, item.price)}
        accessible
        testID="qa_UpsellContainer"
        nativeID="qa_UpsellContainer"
      >
        <View style={styles.flexContainer}>
          <View style={styles.itemView}>
            <Text
              style={styles.upsellLabelName}
              accessible
              testID="qa_UpsellName_txt"
              nativeID="qa_UpsellName_txt"
            >
              {item.name}
            </Text>
            <Text
              style={styles.priceText}
              accessible
              testID="qa_UpsellPrice_txt"
              nativeID="qa_UpsellPrice_txt"
            >
              {Util.formatCurrency(
                null,
                item.price,
                AccountStore.getCurrency(),
              )}
            </Text>
          </View>
          {((props.location?.locationFeatures?.dna?.showCalories &&
            item.calories !== null) ||
            item?.points > 0) &&
            (Settings.isRefiveAnd365PayOnly() ? (
              <View style={styles.rewardsPointsTextView}>
                {item?.points > 0 && (
                  <View style={styles.pointsContainer}>
                    <Text
                      style={styles.rewardsPointsText}
                      accessible
                      testID="qa_UpsellPoints_txt"
                      nativeID="qa_UpsellPoints_txt"
                    >
                      {`${
                        item.points
                      } ${Localized.Labels.points.toLowerCase()}`}
                    </Text>
                  </View>
                )}
                {props.location?.locationFeatures?.dna?.showCalories &&
                  item.calories !== null && (
                    <View style={styles.calorieContainer}>
                      <Text style={styles.calorieText}>
                        {`${item.calories} ${calUnit}`}
                      </Text>
                    </View>
                  )}
              </View>
            ) : (
              <View style={getPickupLocationStyles().upsellPointsView}>
                {props.location?.locationFeatures?.dna?.showCalories &&
                  item.calories !== null && (
                    <Text style={styles.calorieText}>
                      {`${item.calories} ${calUnit}`}
                    </Text>
                  )}
                {item?.points > 0 &&
                  props.location?.locationFeatures?.dna?.showCalories &&
                  item.calories !== null && (
                    <View style={styles.verticleLine} />
                  )}
                {item?.points > 0 && (
                  <Text
                    style={getPickupLocationStyles().upsellPointsText}
                    accessible
                    testID="qa_UpsellPoints_txt"
                    nativeID="qa_UpsellPoints_txt"
                  >
                    {`${item.points} ${Localized.Labels.points.toLowerCase()}`}
                  </Text>
                )}
              </View>
            ))}
        </View>
      </Pressable>
    );
  };
  const renderBackdropComponent = (props: BottomSheetBackdropProps) => {
    return <Pressable style={props.style} onPress={handleBackdropPress} />;
  };

  const handleBackdropPress = () => {
    if (bottomSheetCurrentState === undefined) {
      NavActions.pop();
    } else if (bottomSheetRef.current) {
      bottomSheetRef.current.forceClose();
    }
  };

  const renderUpsellSections = (modifiers: ProductModifierType[]) => {
    const sections = modifiers.map((modifier) => ({
      title: modifier.name,
      data: modifier.vals,
      modifierId: modifier.id,
    }));

    return (
      <SectionList
        sections={sections}
        keyExtractor={(item) => item.id}
        renderItem={({item, section}) =>
          renderProduct(item, section.modifierId)
        }
        renderSectionHeader={({section: {title}}) => (
          <Text style={styles.sectionListStyle}>{title}</Text>
        )}
        stickySectionHeadersEnabled={false}
        contentContainerStyle={{paddingBottom: Styles.Spacing.m3}}
        showsVerticalScrollIndicator={false}
      />
    );
  };

  const renderBottomSheet = () => {
    const addItemButtonText =
      itemCount > 0
        ? `${Localized.Labels.formatString(
            Localized.Buttons.add_items_selected,
            itemCount,
          )}`
        : Localized.Buttons.add_items;
    return (
      <BottomSheet
        ref={bottomSheetRef}
        snapPoints={['65%']}
        enableHandlePanningGesture={true}
        onClose={() => toNextScreen(true)}
        enablePanDownToClose={true}
        enableContentPanningGesture={false}
        backdropComponent={renderBackdropComponent}
      >
        <BottomSheetScrollView>
          <View style={[styles.flexContainer, {marginBottom: insets.bottom}]}>
            <View
              style={{marginVertical: Styles.Spacing.m2}}
              accessible
              testID="qa_UpsellDrinksTitle_txt"
              nativeID="qa_UpsellDrinksTitle_txt"
            >
              <Text style={styles.upsellLabel}>{tab.desc}</Text>
            </View>
            <ScrollView style={styles.innerViewFlex}>
              {renderUpsellSections(tab.modifiers)}
            </ScrollView>
            {getUpsellButton({
              onPress: () => addItem(),
              isDiabled: itemCount <= 0,
              label: addItemButtonText,
              rightText: Util.formatCurrency(
                props,
                upsellPriceTotal,
                AccountStore.getCurrency(),
              ),
            })}
          </View>
        </BottomSheetScrollView>
      </BottomSheet>
    );
  };

  return (
    <SafeAreaView style={styles.container} backgroundStyle={styles.safeArea}>
      <Pressable
        nativeID={'Btn-touchableAreaStyle-close'}
        style={styles.touchableAreaStyle}
        onPress={() => bottomSheetRef.current?.close()}
      />
      {Platform.OS === 'web' ? renderWebModal() : renderBottomSheet()}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  productView: {
    paddingVertical: Styles.Spacing.m3,
    paddingHorizontal: Styles.Spacing.m3,
    borderColor: Styles.Colors.PayNew.neutralHuesBase11,
    flexDirection: 'row',
    marginHorizontal: 24,
    alignItems: 'center',
    minHeight: Styles.Heights.touchTargetHeight2,
    marginTop: Styles.Spacing.m3,
    marginBottom: Styles.Spacing.m1,
    borderWidth: 1.5,
    borderRadius: Styles.Spacing.m2,
    backgroundColor: Styles.Colors.PayNew.white01,
  },
  productViewHighlight: {
    flexDirection: 'row',
    borderColor: Styles.Colors.PayNew.primary01,
    paddingVertical: Styles.Spacing.m3,
    paddingHorizontal: Styles.Spacing.m3,
    borderWidth: 1.5,
    alignItems: 'center',
    borderRadius: Styles.Spacing.m2,
    minHeight: Styles.Heights.touchTargetHeight2,
    marginHorizontal: 24,
    marginTop: Styles.Spacing.m3,
    marginBottom: Styles.Spacing.m1,
    backgroundColor: upsellSelectedBackground(),
    ...upsellSheetStyles().upsellSelectedView,
  },
  calorieText: {
    fontSize: getLayoutDescriber().bodySmallFontSize(),
    fontWeight: '400',
    color: calorieTextColor(),
    fontFamily: mainFontFamily(),
  },
  extraStyles: {flex: 1, alignItems: 'center'},
  verticleLine: {
    borderWidth: 1,
    borderColor: Styles.footerTabInactive,
    backgroundColor: Styles.footerTabInactive,
    marginHorizontal: Styles.Spacing.m2,
    height: Styles.Spacing.m3,
    top: 3,
  },
  rewardsPointsTextView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    paddingTop: 5,
  },

  pointsContainer: {
    flex: 1,
    justifyContent: 'flex-start',
  },

  calorieContainer: {
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flex: 1,
  },

  rewardsPointsText: {
    fontSize: getLayoutDescriber().bodySmallFontSize(),
    fontWeight: '400',
    color: Styles.Colors.PayNew.darkHuesBase04,
    fontFamily: mainFontFamily(),
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContent: {
    width: '100%',
    maxWidth: Styles.ScreenWidth * 0.6,
    minWidth: Styles.Widths.minDialogWidth,
    height: Styles.ScreenHeight * 0.6,
    backgroundColor: Styles.Colors.PayNew.white01,
    borderRadius: Styles.Spacing.m3,
    paddingHorizontal: Styles.Spacing.m3,
    paddingTop: Styles.Spacing.m3 + Styles.Spacing.m2,
    paddingBottom: Styles.Spacing.m2,
    overflow: 'hidden',
  },
  closeIcon: {
    position: 'absolute',
    top: Styles.Spacing.m1 + 1,
    width: Styles.Heights.touchTargetHeight2,
    height: Styles.Heights.touchTargetHeight2,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: Styles.Spacing.m3 + Styles.Spacing.m2,
    zIndex: 999,
    right: Styles.Spacing.m1 + 1,
  },
  scrollContainer: {
    flexGrow: 1,
    paddingBottom: Styles.Spacing.m2 + Styles.Spacing.m1,
  },
  tabDescription: {
    fontSize: getLayoutDescriber().subHeaderFontSize(),
    fontWeight: '700',
    color: Styles.Colors.PayNew.black01,
    textAlign: 'center',
    marginBottom: Styles.Spacing.m2,
    fontFamily: mainFontFamily(),
  },
  buttonView: {marginTop: Styles.Spacing.m3, alignItems: 'center'},
  sectionListStyle: {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    color: Styles.Colors.PayNew.black01,
    width: '100%',
    marginTop: Styles.Spacing.m3,
    marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
    fontFamily: mainFontFamily(),
  },
  touchableAreaStyle: {
    width: '100%',
    height: '35%',
    backgroundColor: Styles.transparent,
  },
  flexContainer: {flex: 1},
  upsellLabel: {
    fontSize: getLayoutDescriber().subHeaderFontSize(),
    fontWeight: '700',
    color: Styles.Colors.PayNew.black01,
    width: '100%',
    textAlign: 'center',
    fontFamily: mainFontFamily(),
  },
  itemView: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  upsellLabelName: {
    flex: 6.5,
    paddingRight: Styles.Spacing.m2,
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    color: Styles.Colors.PayNew.black01,
    fontFamily: mainFontFamily(),
  },
  priceText: {
    flex: 3.5,
    textAlign: 'right',
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    color: Styles.Colors.PayNew.black01,
    fontFamily: mainFontFamily(),
  },
  innerViewFlex: {flex: 6},
  safeArea: {backgroundColor: 'transparent'},
});
export default withForwardedNavigationParams()(
  withGlobalize(ProductUpsellSheetScreen),
);
